import {Injectable} from '@angular/core';
import {ProductParameterFormatState, Store as ProductParameterFormatStore} from './store';
import {EntityService} from '../../../components/entity-service';
import {ProductParameterFormat} from './model';
import {FieldConfig} from '../../../components/form/field.interface';
import {Validators} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {map, shareReplay, switchMap} from 'rxjs/operators';
import {ProductParameterFormatQuery} from './query';

@Injectable({ providedIn: 'root' })
export class ProductParameterFormatService extends EntityService<ProductParameterFormatStore, ProductParameterFormatState> {

  productParameterFormats$ = this.get().pipe(
    switchMap(() => this.query.selectAll()),
    map(items => items.map(item => new ProductParameterFormat(item)).sort((u1, u2) => u1.toString() > u2.toString() ? 1 : -1)),
    shareReplay(1)
  );
  editForm = {
    cancelTitle: this.translocoService.selectTranslate('form.cancel'),
    submitTitle: this.translocoService.selectTranslate('form.submit'),
    entityTitle: this.translocoService.selectTranslate('productParameterFormat.entityTitle'),
    fields: [
      FieldConfig.create({
        type: 'input',
        label: this.translocoService.selectTranslate('productParameterFormat.name'),
        inputType: 'text',
        name: 'name',
        listed: true,
        validations: [
          {
            name: 'required',
            validator: Validators.required,
            message$: this.translocoService.selectTranslate('form.required')
          }
        ]
      }),
    ]
  };

  constructor(
    protected translocoService: TranslocoService,
    private query: ProductParameterFormatQuery,
    protected store: ProductParameterFormatStore) {
    super(store, ProductParameterFormat);
  }

  get resourceName(): string {
    return 'products/product-parameter-format';
  }

}
